import React, { useEffect } from "react";
import { any } from "prop-types";

import { PopupButton } from "@typeform/embed-react";

import Cover from "../components/cover";
import PageAnimationHandler from "../ui-components/animations/page-animation-handler";

import { GigaTitle, MediumTitle, SmallText } from "../ui-components/texts";
import { ContainerBlock } from "../ui-components/columns/components";
import {
	SectionImagesServices,
	SectionServicesMasamune,
} from "../components/services-components";

import imageTopCover from "../media/images/services-page/4.jpg";
import imageBottomCover from "../media/images/services-page/1.jpg";
import { useTranslate } from "../contexts/translate";

const Services = ({
	setNextPageHref = () => {},
	setNextPageName = () => {},
}) => {
	const { translations } = useTranslate();

	useEffect(() => {
		setNextPageHref("/projects");
		setNextPageName(
			translations === null ? "" : translations.navbar.links.works
		);
		document.title = 'Services - Cutting Edge Digital Creative Studio'
	}, [translations]);

	return (
		<section className="services-page-component">
			<Cover imageTop={imageTopCover} imageBottom={imageBottomCover}>
				<GigaTitle className="min-line-height">
					<span className="text-animation animation-delay-05s">
						Get the edge
					</span>
					<span className="text-animation animation-delay-05s">
						you deserve
					</span>
				</GigaTitle>
			</Cover>
			<section className="theme-light mid-padding light-section full-height d-flex">
				<ContainerBlock className="m-auto h-auto">
					<SmallText>
						{translations === null ? "" : translations.services.section1Sub}
					</SmallText>
					<MediumTitle>
						{translations === null ? "" : translations.services.section1Title}
					</MediumTitle>
				</ContainerBlock>
			</section>

			<SectionImagesServices />
			<SectionServicesMasamune translations={translations} />
			<div className="cta-single-project">
									<div className="cta-single-project-inner">
										<p>{translations && translations.ctaapproach.text}</p>
										<button
											className="leadconnector-button"
											onClick={() => {
												const overlay = document.createElement('div');
												overlay.style.cssText = `
													position: fixed;
													top: 0;
													left: 0;
													width: 100%;
													height: 100%;
													background-color: rgba(0, 0, 0, 0.7);
													backdrop-filter: blur(5px);
													z-index: 9998;
												`;
												
												const modal = document.createElement('div');
												modal.style.cssText = `
													position: fixed;
													top: 0;
													left: 0;
													width: 100%;
													height: 100%;
													z-index: 9999;
												`;
												
												const closeBtn = document.createElement('button');
												closeBtn.innerHTML = '✕';
												closeBtn.style.cssText = `
													position: fixed;
													top: 30px;
													right: 30px;
													width: 50px;
													height: 50px;
													border: none;
													background-color: rgba(255, 255, 255, 0.2);
													color: white;
													border-radius: 50%;
													cursor: pointer;
													font-size: 28px;
													z-index: 10000;
													transition: all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
													backdrop-filter: blur(10px);
													border: 1px solid rgba(255, 255, 255, 0.3);
													display: flex;
													align-items: center;
													justify-content: center;
												`;
												closeBtn.onmouseover = () => {
													closeBtn.style.backgroundColor = 'rgba(255, 255, 255, 0.3)';
													closeBtn.style.transform = 'scale(1.15) rotate(90deg)';
													closeBtn.style.boxShadow = '0 8px 32px rgba(0, 0, 0, 0.3)';
													closeBtn.style.borderColor = 'rgba(255, 255, 255, 0.5)';
												};
												closeBtn.onmouseout = () => {
													closeBtn.style.backgroundColor = 'rgba(255, 255, 255, 0.2)';
													closeBtn.style.transform = 'scale(1) rotate(0deg)';
													closeBtn.style.boxShadow = 'none';
													closeBtn.style.borderColor = 'rgba(255, 255, 255, 0.3)';
												};
												closeBtn.onclick = () => {
													overlay.style.opacity = '0';
													modal.style.opacity = '0';
													overlay.style.transition = 'opacity 0.4s ease-out';
													modal.style.transition = 'opacity 0.4s ease-out';
													setTimeout(() => {
														document.body.removeChild(overlay);
														document.body.removeChild(modal);
													}, 400);
												};
												
												const iframe = document.createElement('iframe');
												iframe.src = 'https://api.leadconnectorhq.com/widget/survey/fXRdOm9p3aM4iNGpHfOa?notrack=true';
												iframe.style.cssText = `
													width: 100%;
													height: 100%;
													border: none;
												`;
												iframe.allowFullscreen = true;
												
												modal.appendChild(iframe);
												modal.appendChild(closeBtn);
												document.body.appendChild(overlay);
												document.body.appendChild(modal);
												
												overlay.onclick = () => {
													document.body.removeChild(overlay);
													document.body.removeChild(modal);
												};
											}}
										>
											{translations && translations.ctaapproach.button}
										</button>
									</div>
								</div>
		</section>
	);
};

Services.propTypes = {
	setNextPageHref: any,
	setNextPageName: any,
};

export default Services;
